import { Empty as AntEmpty } from "antd";

const Empty = AntEmpty;

export default Empty;
